export const borders = {
  // empty
}

export type Borders = typeof borders
export type BordersType = keyof Borders | string
